import React from 'react'
import classNames from 'classnames'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { Placeholder } from '@/atoms/Placeholder'

export const RecommendedBannerCarouselFullPlaceholder = () => {
  return (
    <div className="relative -mx-4 flex flex-col sm:-mx-8 md:-mx-12 xl:-mx-16">
      <div className="relative flex min-h-[60vh] w-full flex-col gap-4 bg-transparent md:min-h-[45vh] lg:min-h-[50vh] lg:flex-row lg:flex-wrap lg:items-center xl:min-h-[53vh] 2xl:min-h-[630px]">
        <PaddedContainer fluid className="flex items-center justify-center">
          <div className="relative mt-[23vh] w-full pt-24 md:mt-6 lg:mt-10 lg:max-w-[600px] xl:max-w-[650px]">
            {/* Logo Placeholder */}
            <Placeholder
              className="mb-4 flex min-h-[64px] w-auto max-w-full animate-pulse items-center justify-center rounded bg-core-gray-700 object-contain md:mb-2 md:justify-start"
              style={{ animationDelay: '0s' }}
            />
            {/* Flavor Text Placeholder */}
            <div className="mb-2 lg:mb-4">
              <Placeholder
                className="mx-auto min-h-9 w-2/3 animate-pulse rounded bg-core-gray-800 text-center md:mx-0 md:text-left lg:min-h-[18px]"
                style={{ animationDelay: '0.1s' }}
              />
            </div>
            {/* Metadata Row Placeholder */}
            <div className="mb-2 flex flex-row flex-wrap items-center justify-center gap-1 md:justify-start lg:mb-4 lg:gap-2">
              <Placeholder
                className="h-4 w-8 animate-pulse rounded bg-core-gray-800 duration-300"
                style={{ animationDelay: '0.2s' }}
              />
              <Placeholder
                className="h-4 w-16 animate-pulse rounded bg-core-gray-800 duration-150"
                style={{ animationDelay: '0.3s' }}
              />
              <Placeholder
                className="h-4 w-12 animate-pulse rounded bg-core-gray-800 duration-200"
                style={{ animationDelay: '0.4s' }}
              />
            </div>
            {/* Badges Row Placeholder */}
            <div className="md:min-h-auto mb-4 flex min-h-[47px] flex-row flex-wrap items-center justify-center gap-2 md:justify-start lg:mb-8 lg:min-h-7">
              <Placeholder
                className="h-6 w-16 animate-pulse rounded-xl bg-core-gray-800 duration-300"
                style={{ animationDelay: '0.5s' }}
              />
              <Placeholder
                className="h-6 w-16 animate-pulse rounded-xl bg-core-gray-800 duration-200"
                style={{ animationDelay: '0.6s' }}
              />
              <Placeholder
                className="h-6 w-16 animate-pulse rounded-xl bg-core-gray-800 duration-300"
                style={{ animationDelay: '0.7s' }}
              />
              <Placeholder
                className="h-6 w-16 animate-pulse rounded-xl bg-core-gray-800 duration-150"
                style={{ animationDelay: '0.8s' }}
              />
            </div>
            {/* CTA Button Placeholder */}
            <Placeholder
              className="flex max-h-12 min-h-12 w-full min-w-full animate-pulse items-center gap-[6px] rounded-xl bg-core-gray-800 px-6 py-[14px] md:w-fit md:min-w-[200px]"
              style={{ animationDelay: '0.9s' }}
            />
          </div>
        </PaddedContainer>
      </div>
      {/* Dots Placeholder */}
      <div className="mt-4 flex w-full items-center justify-center md:mt-0">
        <ul className="flex h-full min-w-[98px] flex-row gap-1 md:items-end md:pb-2">
          {[...Array(4)].map((_, idx) => (
            <li key={idx} className="flex cursor-pointer items-center justify-center p-1">
              <div
                className={classNames('h-2.5 w-2.5 rounded-full bg-core-gray-800 animate-pulse', {
                  '!w-8 bg-core-gray-700': idx === 0,
                })}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
